module.exports = __webpack_public_path__ + "img/ixaru.31bf8c46.png";